import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import * as types from './types';

// Mutations Object for ReleasesCatalog. Use it by importing releases/types.js and calling commit() from  releases/actions.js Action File.
export const releasesCatalogMutations = {
  [types.ReleaseList.SET.ALL] (state, payload) {
    console.log("MUT PAYLOAD",payload)
  
      state.releasesCatalogData = payload
     //.releasesCatalogData;
   // state.releaseCatalogMetaData=payload.releaseCatalogMetaData;
  },
  [types.ReleasesCatalogData.SET.ALL] (state, payload) {
    //state.releasesCatalogData = payload.releasesCatalogData;
    state.releaseCatalogMetaData=payload;
  },
  [types.ReleaseRelatedContacts.SET.ALL](state,payload){
    state.releaseDetails.contact_relations=payload
  },

  ...implementSetAllNavTabDetailsMutation(types.ReleaseDetails,  'releaseDetails'),
}